export default {
    global: {

    },
    login: {
        login: 'Login',
        normal: 'normal',
        admin: 'admin'

    },
    goods: {
        goods: 'Goods',
        detail: 'Detail',
        table: {
            title: 'Title',
            price: 'Price',
            action: 'Action'
        }
    },
    customer: {
        customer: 'Customer'
    },
    order: {
        order: 'Order',
        detail: 'Detail',
        table: {
            orderId: 'ID',
            title: 'Title',
	        attribute: 'Goods Attribute',
            price: 'Price',
            count: 'Count',
            status: 'Status',
            time: 'Create Time',
            evaluate: 'Evaluate'
        }
    },
    industry: {
        industry: 'Industry'
    },
    logistics: {
        logistics: 'Logistics'
    },
    servicio: {
        servicio: 'Service'
    }
}
